interface IPaymentOptions {
  value: "credito" | "debito" | "boleto" | "pix";
  setValue: (val: "credito" | "debito" | "boleto" | "pix") => void;
}

const InDevelopment = ({ type, icon }: { type: string; icon: string }) => {
  return (
    <>
      <p
        style={{
          color: "white",

          backgroundColor: "rgba(0,0,0,0.6)",
          width: "80%",
          padding: 5,
          position: "absolute",
          left: "50%",
          transform: "translateX(-50%)",
        }}
        className="disable-text"
      >
        EM BREVE
      </p>
      <i className={icon}></i>
      {type}
    </>
  );
};

const PaymentOptions = ({ value, setValue }: IPaymentOptions) => {
  const onClickOption = (option: "credito" | "debito" | "boleto" | "pix") => {
    setValue(option);
  };

  return (
    <div
      className="btn-group mb-3"
      role="group"
      aria-label="Basic checkbox toggle button group"
    >
      <button
        onClick={() => onClickOption("credito")}
        className={
          value === "credito" ? "btn btn-primary" : "btn btn-outline-secondary"
        }
      >
        <i className="fs-1 d-block las la-credit-card opacity-50"></i>Crédito
      </button>
      <button
        disabled
        onClick={() => onClickOption("debito")}
        className={
          value === "debito"
            ? "btn btn-primary"
            : "btn btn-outline-secondary disable-button"
        }
      >
        <InDevelopment
          type="Débito"
          icon="fs-1 d-block las la-money-check-alt opacity-50"
        />
      </button>
      <button
        disabled
        onClick={() => onClickOption("boleto")}
        className={
          value === "boleto"
            ? "btn btn-primary"
            : "btn btn-outline-secondary disable-button"
        }
      >
        <InDevelopment
          type="Boleto"
          icon="fs-1 d-block las la-barcode opacity-50"
        />
      </button>
      <button
        disabled
        onClick={() => onClickOption("pix")}
        className={
          value === "pix"
            ? "btn btn-primary"
            : "btn btn-outline-secondary disable-button"
        }
      >
        <InDevelopment
          type="PIX"
          icon="fs-1 d-block las la-mobile opacity-50"
        />
      </button>
    </div>
  );
};

export default PaymentOptions;
